<template>
  <div class="c-item" @click="clickHandle">
    <div class="c-thumb c-default-img">
      <img :src="item.image" />
    </div>
    <div class="c-info">
      <div class="c-title tl" v-html="item.name"></div>
      <div class="c-course-info">
        <div
          class="c-teacher"
        >{{item.teacherName ? item.teacherName.substring(0,4)+' · ' : ''}}{{item.readCount > 999999 ? '100万+' : item.readCount}}人阅读</div>
        <div class="c-lesson-progress">{{dates.formatDate(item.publishTime, 'yyyy-MM-dd')}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import dates from '@/utils/dates'
export default {
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      dates,
    }
  },
  emits: ['click'],
  methods: {
    clickHandle() {
      this.$emit('click', this.item)
    },
  },
}
</script>

<style lang="less" scoped>
.c-item {
  display: flex;
  .c-thumb {
    flex: 240px 0 0;
    height: 160px;
    border-radius: 10px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .c-info {
    flex: 1 0 0;
    padding-left: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .c-title {
    width: 434px;
    font-size: 30px;
    font-weight: 500;
    color: #333333;
    line-height: 42px;
    height: 84px;
    overflow: hidden;
  }
  .c-course-info {
    display: flex;
    justify-content: space-between;
    padding-top: 50px;
    line-height: 1;
    color: #bbb;
    font-size: 22px;
  }
}
</style>